import { Extension } from "@tiptap/core";
const NBSP = "\u00A0";

const NbspRules = [
  // Инициалы: "И. " → "И.&nbsp;"
  {
    regex: /(?<![а-яА-Яa-zA-Z])([а-яА-Яa-zA-Z])\.\s/g,
    replace: "$1." + NBSP,
  },

  // Перед знаками препинания: "текст !" → "текст&nbsp;!"
  {
    regex: /\s([?!;:—])/g,
    replace: NBSP + "$1",
  },

  // После открывающей скобки: "( " → "(&nbsp;"
  {
    regex: /\(\s/g,
    replace: "(" + NBSP,
  },

  // Перед закрывающей скобкой: " )" → ")&nbsp;"
  {
    regex: /\s\)/g,
    replace: NBSP + ")",
  },

  // Предлоги и союзы
  {
    regex:
      /(а|во|на|не|в|по|и|но|да|или|что|как|если|когда|где|куда|откуда|хотя|пока|между|после|перед|за|до|без|при|через|над|под|около|чтобы|из)\s+/gi,
    replace: "$1" + NBSP,
  },

  // Число + единица измерения: "10 кг" → "10&nbsp;кг"
  {
    regex: /(\d)\s+(кг|г|л|мл|м|см|мм|км|°C|°F|₽|\$|€|%)\b/g,
    replace: "$1" + NBSP + "$2",
  },

  // Дроби: "1 / 2" → "1&nbsp;/&nbsp;2"
  {
    regex: /(\d)\s*\/\s*(\d)/g,
    replace: "$1" + NBSP + "/" + NBSP + "$2",
  },
];

export function applyNbspRules(text) {
  let result = text;

  for (const rule of NbspRules) {
    result = result.replace(rule.regex, rule.replace);
  }

  // Убираем дублирование NBSP
  result = result.replace(new RegExp(NBSP + "+", "g"), NBSP);

  return result;
}

export const AutoNbsp = Extension.create({
  name: "autoNbsp",

  addCommands() {
    return {
      applyAutoNbsp:
        () =>
        ({ state, dispatch }) => {
          const tr = state.tr;
          let changed = false;

          state.doc.descendants((node, pos) => {
            if (!node.isText || !node.text) return;

            const newText = applyNbspRules(node.text);
            if (newText !== node.text) {
              tr.replaceWith(
                pos,
                pos + node.text.length,
                state.schema.text(newText),
              );
              changed = true;
            }
          });

          if (changed && dispatch) {
            dispatch(tr);
          }
          return changed;
        },
    };
  },
});
